var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiToggleButton from '@material-ui/lab/ToggleButton';
/**
 * Kareo wrapped component of the Material-UI ToggleButton. The prop API has been limited to props defined in ToggleButtonProps.
 *
 * Toggle buttons can be used to group related options.
 *
 * Material-UI ToggleButton: [ToggleButton](https://v4.mui.com/components/toggle-button/), [API](https://https://v4.mui.com/api/toggle-button/)
 *
 * @storybook: [ToggleButton](http://design.kareoprod.ent/?path=/story/components-data-display-togglebutton--toggle-button-example)
 */
var ToggleButton = function (props) {
    return React.createElement(MuiToggleButton, __assign({}, props));
};
ToggleButton.defaultProps = {};
ToggleButton.displayName = 'KareoToggleButton';
export default ToggleButton;
